import { client }  from '../OwnWebsocket';
import { hostUrl, siteUrl } from '../../constants/global';
import samplepdf from '../../assets/pdf/sample-latest.pdf';
import Player from '@vimeo/player';
import Moment from 'moment';


/********HeaderScroll***********/
export const HeaderScroll = () => {

    window.addEventListener('scroll', function() {
        var topHeader  = document.querySelector('.topheader');
        topHeader.classList.toggle("scroll",  window.pageYOffset >= 50);
    });

}

/********fetch client ip address and call websocket to save tracking*************/
export const callPageRenderTracking = (data) => {

    /********sending component data to websocket*********/
    setTimeout(function(){ 
        //console.log("in set timeout");
        /********check websocket not in connecting and close state*********/
        if(client.readyState!=0 && client.readyState!=3){
            //console.log("in helper state");
            //https://api.ipify.org?format=json
            fetch('https://geolocation-db.com/json/d802faa0-10bd-11ec-b2fe-47a0872c6708').then(response => {
                    return response.json();
                }).then((res) => {
                    //console.log(res, "in featch");
                    if(res.IPv4){
                        var objData = {
                            ip_address: res.IPv4,
                            user_agent: window.navigator.userAgent,
                            page_title: data.page_title,
                            page_link:data.page_link,
                            action: 'pageRenderUserToAdmin'
                        };
                        client.send(JSON.stringify(objData));
                    }
                });
            }

        }, 5000);
 };


/**********Download Brochure and Documents************/
export const downloadFile = (event, fileURL) => {

    event.currentTarget.disabled = true;
    event.currentTarget.setAttribute('id','current-loading');
    //var currentButtonHTML = event.currentTarget.innerHTML;
    event.currentTarget.innerHTML = "<span class='material-icons-outlined spin'>motion_photos_on</span> Downloading...";

    var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);

    /******get data from localstorage*******/
    let authlogin = localStorage.getItem('authlogin');
    let storageData = authlogin ? JSON.parse(authlogin) : "";
    var token = 'Bearer '+storageData.token;

    var data_title = event.currentTarget.getAttribute("data-title");
    var data_type = event.currentTarget.getAttribute("data-type");

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 
        'POST' : '/resource HTTP/1.1',
        'Authorization': token,
        'Host' : hostUrl,
        }
     };


    fetch(fileURL,requestOptions)
    .then((response) => response.blob())
    .then((blob) => {

        // Create blob link to download
        const url = window.URL.createObjectURL(
        new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        //link.download = filename+'.pdf';
        link.download = filename;
        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);


        document.getElementById("current-loading").removeAttribute("disabled");
        const currentElement = document.getElementById('current-loading');
        // ✅ Remove ID attribute
        currentElement.innerHTML = '<span class="material-icons-outlined">file_download</span> Download';
        currentElement.removeAttribute('id');

        /*******Brochure download entry in database********/
        var storageCiisummit = localStorage.getItem('_ciisummit');
        var myHeaders = new Headers();
        var formdata = new FormData();
        formdata.append("username", storageData.user_email);
        formdata.append("cookie_id", storageCiisummit);
        formdata.append("user_agent", window.navigator.userAgent);
        formdata.append("title", data_title);
        formdata.append("item_identity", data_type);
        formdata.append("source", "ClearTrail Technologies");

        var requestOptionsLogin = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
        };

        return fetch(siteUrl+'/community-rest-functions.php?action=brochure_download_entry',requestOptionsLogin);
        /********brochure download entry end********/

    });

}

/******get user short name*********/
export const shortNameUser = (str)=> {
    var short_name =  str.split(' ').map(word => word[0]).join('');
    var first_two_chars_short_name = short_name.slice(0, 2);
    return first_two_chars_short_name;
}


export const formatPostDate = (post_date) => {
    const formatDate = Moment(post_date).format('MMMM Do, Y');
    return formatDate;
}